var collapsible_list_component_rtlignore_default = {
  "ltr": "mmJVU",
  "rtl": "d0FVC",
  "iconContainer": "obQ1D",
  "icon": "_370J1",
  "isExpanded": "-Qm--",
  "listDimensions": "_2wYSk"
};
export {
  collapsible_list_component_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-component.rtlignore-scss.js.map
